import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Box,
  TablePagination,
  Chip,
  Snackbar,
  Alert,
} from "@mui/material";
import TableContainer from "../../Components/TableContainer/TableContainer";
import { loader } from "../../utils";
import { getAllIptvUserRequest } from "../../Components/service/admin";
import { Button } from "reactstrap";
import axios from "axios";
import { useDispatch } from "react-redux";
import { success, error } from "../../Store/SnackbarSlice";

const IptvUserRequest = () => {
  const [data, setData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalData, setTotalData] = useState(0);
  const dispatch = useDispatch();

  const getIptvUserRequests = async () => {
    try {
      loader.start();
      const response = await getAllIptvUserRequest();
      const requestData = response.data.data || [];

      // Sort by creation date (newest first)
      requestData.sort((a, b) => {
        const aDate = new Date(a?.createdAt);
        const bDate = new Date(b?.createdAt);
        return bDate - aDate;
      });

      setAllData(requestData);
      setFilteredData(requestData);
      setTotalData(requestData?.length || 0);
      paginate(requestData, 0);
      loader.stop();
    } catch (error) {
      console.error("Error fetching IPTV user requests:", error);
      loader.stop();
    }
  };

  function filterData(searchValue) {
    setSearchInput(searchValue);
    setPage(0);

    if (!searchValue.trim()) {
      setFilteredData(allData);
      setTotalData(allData.length);
      paginate(allData, 0);
    } else {
      const filtered = allData.filter(
        (item) =>
          item?.mobile?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item?.plan?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item?.paymentId?.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
      setTotalData(filtered.length);
      paginate(filtered, 0);
    }
  }

  function paginate(data, pageNumber) {
    const startIndex = pageNumber * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedData = data.slice(startIndex, endIndex);
    setData(paginatedData);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    paginate(filteredData, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    paginate(filteredData, 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusChip = (status) => {
    const statusColors = {
      pending: "warning",
      approved: "success",
      rejected: "error",
      processing: "info",
    };

    return (
      <Chip
        label={status || "pending"}
        color={statusColors[status?.toLowerCase()] || "default"}
        size="small"
        variant="outlined"
      />
    );
  };

  const handleActivation = async (mobile, status) => {
    console.log("activatation", mobile, status);

    try {
      const ziggRes = await axios.put(
        "http://localhost:4006/iptv_request/update-status",
        { mobile, status }
      );
      getIptvUserRequests();
      dispatch(success({ show: true, msg: "IPTV Activated Successfully!" }));
    } catch (error) {
      dispatch(error({ show: true, msg: "IPTV Activation Failed!" }));
    }
  };

  useEffect(() => {
    getIptvUserRequests();
  }, []);

  return (
    <div>
      <Typography variant="h4" className="mb-4">
        IPTV User Requests
      </Typography>

      <TableContainer
        heading="IPTV User Requests"
        btnText=""
        filterData={filterData}
        searchInput={searchInput}
        totalData={totalData}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Plan</TableCell>
              <TableCell>Validity (Months)</TableCell>
              <TableCell>Payment ID</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Status fast1</TableCell>
              <TableCell>Request Date</TableCell>
              <TableCell>Activated At</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <TableRow key={item._id || index}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{item.mobile || "N/A"}</TableCell>
                  <TableCell>{item.plan || "N/A"}</TableCell>
                  <TableCell>{item.validity || "N/A"}</TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                      {item.paymentId || "N/A"}
                    </Typography>
                  </TableCell>
                  <TableCell>{getStatusChip(item.status)}</TableCell>
                  <TableCell>
                    {getStatusChip(
                      item.syncToFast1 === true ? "Active" : "Inactive"
                    )}
                  </TableCell>
                  <TableCell>{formatDate(item.createdAt)}</TableCell>
                  <TableCell>
                    {item.activatedAt ? (
                      formatDate(item.activatedAt)
                    ) : (
                      <Chip
                        label="Not Activated"
                        color="default"
                        size="small"
                        variant="outlined"
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    {item.status !== "active" ? (
                      <Button
                        color="success"
                        onClick={() => handleActivation(item.mobile, "active")}
                      >
                        Activate
                      </Button>
                    ) : (
                      ""
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="body2" color="textSecondary">
                    No IPTV user requests found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {totalData > 0 && (
          <Box className="d-flex justify-content-end mt-3">
            <TablePagination
              component="div"
              count={totalData}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </Box>
        )}
      </TableContainer>
    </div>
  );
};

export default IptvUserRequest;
